/**
 * 清理工具函数
 * 用于在退出登录时清理所有相关资源
 */

/**
 * 清理所有localStorage和sessionStorage
 */
export function clearAllStorage() {
  try {
    localStorage.clear();
    sessionStorage.clear();
    console.log('所有存储已清理');
  } catch (error) {
    console.error('清理存储时出现错误:', error);
  }
}

/**
 * 清理所有全局定时器
 */
export function clearAllTimers() {
  try {
    // 清理全局重连定时器
    if (window.reconnectTimer) {
      clearInterval(window.reconnectTimer);
      window.reconnectTimer = null;
    }
    
    // 清理所有可能的定时器ID（从1到10000，这是一个安全范围）
    for (let i = 1; i <= 10000; i++) {
      clearTimeout(i);
      clearInterval(i);
    }
    
    console.log('所有全局定时器已清理');
  } catch (error) {
    console.error('清理定时器时出现错误:', error);
  }
}

/**
 * 清理所有缓存数据
 */
export function clearAllCache() {
  try {
    // 直接清理所有localStorage和sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    
    console.log('所有缓存数据已清理');
  } catch (error) {
    console.error('清理缓存时出现错误:', error);
  }
}

/**
 * 执行完整的清理操作
 */
export function performFullCleanup() {
  clearAllStorage();
  clearAllTimers();
  console.log('完整清理操作已完成');
}
